import { Box, Typography } from '@mui/material';

import { Button, ButtonVariants, ModalContentContainer } from '@/components';
import { Modals } from '@/constants';
import { playerThunks, uiActions, useAppDispatch } from '@/store';

import { AppModal } from '../AppModal';

export const BrowserAutoPlayModal = () => {
  const dispatch = useAppDispatch();

  const handleClickClose = () => {
    dispatch(uiActions.closeActiveModal());
    dispatch(playerThunks.playPlayer());
  };

  return (
    <AppModal modalName={Modals.BROWSER_AUTOPLAY_PROHIBITED}>
      <ModalContentContainer
        onModalClose={() => dispatch(uiActions.closeActiveModal())}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h3">Let’s Get Listening</Typography>
          <Typography variant="body2" sx={{ color: 'text.main' }}>
            Your browser needs permission to play this episode. Click Allow to
            enable playback and dive right in.
          </Typography>
          <Button
            variant={ButtonVariants.GRADIENT_PRIMARY}
            label="Allow"
            onClick={handleClickClose}
            skinny={false}
          />
        </Box>
      </ModalContentContainer>
    </AppModal>
  );
};
